import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useCallback, useMemo, useState } from "react";
import {
  createMemo,
  memoServiceEs,
  memoServiceOthers,
  useAdminData,
} from "services/AdminUserService";
import authStore from "mobx/AuthStore";
import { BASE_URL } from "services";
import http from "services/httpService";
import { useQuery } from "react-query";
import FullScreenLoader from "../FullScreenLoader";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { observer } from "mobx-react-lite";
import { Modal } from "antd";
import checkboxStore from "mobx/CheckboxStore";

const roleMap = {
  es: "Executive Secretary",
  lo: "Loan Officer",
  lph: "Loan Processing Head",
  la: "Auditor",
  fdo: "Front Desk Officer",
  blog: "Blogger",
  acc: "Accountant",
};

function SendMemoComp({
  user,
  disabled,
  title = "Send Memo",
  selectedLoans = [],
  totalESAmount = 0,
}) {
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [sendMemo, setSendMemo] = useState(false);
  const params = useParams();
  const url = `${BASE_URL}/admin/who_i_am`;
  const fetcher = async () => {
    const res = await http.get(url);
    return res?.data?.data;
  };
  const { data: userProfile } = useQuery("profile", fetcher);
  const onSuccess = () => {};
  const onError = () => {};

  const { isLoading, data: adminData } = useAdminData(onSuccess, onError);

  const toggleSendMemo = () => {
    if (disabled)
      return toast.error(
        "Loan (s) under this table has been disbursed, you cannot send memo anymore",
      );
    setSendMemo(!sendMemo);
  };

  const handleSendMemo = async () => {
    const payload = { ...formik.values };
    payload.id = params?.id ? params.id : "";
    payload.memoId = params?.threadId ? params.threadId : "";

    if (userProfile?.admin_role === "es") {
      const res = await memoServiceEs({
        ...payload,
        selectedLoans: selectedLoans.map((item) => item._id),
      });
      if (!res.error) {
        formik.resetForm();
        toggleSendMemo();
        setConfirmationOpen(false);
      }
    }

    if (userProfile?.admin_role === "lph") {
      const res = await createMemo({
        ...payload,
        selectedLoans: selectedLoans.map((item) => item._id),
      });
      if (!res.error) {
        formik.resetForm();
        toggleSendMemo();
        setConfirmationOpen(false);
      }
    }

    if (userProfile?.admin_role === "la") {
      const res = await memoServiceOthers(payload);
      if (!res.error) {
        formik.resetForm();
        toggleSendMemo();
        setConfirmationOpen(false);
      }
    }
  };

  const data = useMemo(() => {
    const allAdmin = adminData?.data?.data ? adminData?.data?.data : [];
    const adminFilter = allAdmin?.filter(
      (admin) =>
        admin.first_name &&
        (admin.admin_role === "es" || admin.admin_role === "la"),
    );
    const adminFilterEs = allAdmin?.filter(
      (admin) =>
        admin.first_name &&
        (admin.admin_role === "acc" || admin.admin_role === "lph"),
    );
    const adminFilterLa = allAdmin?.filter(
      (admin) => admin.first_name && admin.admin_role === "lph",
    );
    return { adminFilter, adminFilterLa, adminFilterEs };
  }, [adminData?.data?.data]);

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      status: "approved",
      to_admin: "",
      note: "",
    },
    onSubmit: async () => {
      setConfirmationOpen(true);
    },
    validationSchema: Yup.object({
      note: Yup.string().required().label("Messaage"),
      to_admin: Yup.string().required().label("Send To:"),
      status: Yup.string().required().label("Status"),
    }),
  });

  const getTotalSelectedLoan = useCallback(() => {
    let total = 0;

    for (const loan of selectedLoans) {
      total += loan.amount;
    }

    if (total > 0) return total + totalESAmount;

    return total;
  }, [selectedLoans, totalESAmount]);

  const toAdmin =
    userProfile?.admin_role === "es"
      ? data.adminFilterEs
      : userProfile?.admin_role === "la"
        ? data.adminFilterLa
        : userProfile?.admin_role === "lph"
          ? data?.adminFilter
          : [];
  if (isLoading) return <FullScreenLoader show={true} />;

  return (
    <>
      <Modal
        footer={null}
        open={confirmationOpen}
        onCancel={() => setConfirmationOpen(false)}
        centered
      >
        <div className="p-6 text-center">
          <p className="text-3xl font-bold">Confirm Memo Submission</p>
          <p className="my-4 text-base">
            Are you sure you want to submit this memo with{" "}
            <b> {selectedLoans.length} selected loans</b> with a total amount of{" "}
            <b>(₦{getTotalSelectedLoan().toLocaleString()})</b>, this process
            cannot be reversed
          </p>
          <footer className="flex items-center justify-center gap-x-8">
            <button
              onClick={() => setConfirmationOpen(false)}
              className="flex-1 w-full px-6 py-3 text-base text-white bg-red-400 rounded-md"
              type="button"
            >
              Cancel
            </button>
            <button
              onClick={handleSendMemo}
              className="flex-1 w-full px-6 py-3 text-base text-white rounded-md bg-primary"
              disabled={authStore.isLoading}
              type="submit"
            >
              {authStore.isLoading ? "Sending memo..." : "Proceed"}
            </button>
          </footer>
        </div>
      </Modal>
      <div>
        {/* <Div width="100%" display="flex" justify="flex-end"> */}
        <button
          className="px-6 py-2 text-white rounded-md bg-primary"
          onClick={() => toggleSendMemo()}
        >
          {title}
        </button>
        {/* </Div> */}

        <Modal
          centered
          footer={null}
          open={sendMemo}
          onCancel={() => setSendMemo(false)}
        >
          <div className="py-4">
            <h1 className="mb-6 text-xl font-semibold">Send Memo</h1>
            <div>
              <form className="modal-content" onSubmit={formik.handleSubmit}>
                <label className="block mb-1 font-medium">Send To</label>
                <select
                  className="w-full px-4 py-2 text-base bg-gray-200 border-0 rounded-md"
                  name="to_admin"
                  id="to_admin"
                  value={formik.values.to_admin}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  visible={formik.touched.to_admin}
                  width="250px"
                >
                  <option value="">Select receiver</option>
                  {toAdmin?.map((adminuser) => (
                    <option value={adminuser._id}>
                      {adminuser?.surname} {adminuser?.first_name} -{" "}
                      {roleMap[adminuser?.admin_role] || "NIL"}
                    </option>
                  ))}
                </select>
                <p className="mb-6 text-sm text-red-500">
                  {formik.errors.to_admin}
                </p>
                <label className="block mt-8 mb-1 font-medium">
                  Memo Message
                </label>
                <textarea
                  name="note"
                  id="note"
                  className="h-[100px] w-full bg-gray-200 p-3 text-base rounded-md"
                  placeholder="Enter Message"
                  value={formik.values.note}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  visible={formik.touched.note}
                />
                <p className="text-red-600 mb-7">{formik.errors.note}</p>
                <footer className="flex items-center justify-center gap-x-8">
                  <button
                    className="px-6 py-2 text-white bg-red-400 rounded-md"
                    onClick={() => setSendMemo(false)}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="px-6 py-2 text-white rounded-md bg-primary"
                    disabled={authStore.isLoading}
                    type="submit"
                  >
                    {authStore.isLoading ? "Sending memo..." : "Proceed"}
                  </button>
                </footer>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default observer(SendMemoComp);
